/**
 * Route component export file
 */
// import Loadable from 'react-loadable';
import TenantsData from './tenantsdata/TenantsData'
import UpdateLog from './updateLog/UpdateLog'
import DeleteUsersList from './faileDeleteUsers/DeleteUsersList'
import UpdateContactInfo from './updateContactInfo/UpdateContactInfoDynamic'
import ExistingLicense from './existingLicenses/ExistingLicenses'
import AdminManage from './permission/adminManagement/index.jsx'
import RoleManage from './permission/roleManagement/index.jsx'
import AdminOperationLogs from './logs/index.jsx'
import UpdateRegion from './updateRegion/index.jsx'
import UpdateCountry from './updateCountry/index.jsx'
export default {
    TenantsData,
    UpdateLog,
    DeleteUsersList,
    UpdateContactInfo,
    ExistingLicense,
    AdminManage,
    RoleManage,
    AdminOperationLogs,
    UpdateRegion,
    UpdateCountry
}
